// ⚠️⚠️⚠️ Disclaimer: Please tailor this content to suit the specific needs of your business.

import React from "react";
import { IconHome, IconLogin2, IconRss, IconMap, IconDashboard } from "@tabler/icons-react";
import { SpotlightActionData } from "@mantine/spotlight";
import { navigate } from "vike/client/router";

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const searchPages: readonly SpotlightActionData[] = Object.freeze([
  {
    id: "home",
    label: "Home",
    description: "Return to the homepage",
    onClick: () => onSubmit("/"),
    leftSection: <IconHome size={24} stroke={1.5} />,
  },
  {
    id: "log-in",
    label: "Log in",
    description: "Join us by creating a new account or log in to your existing one",
    onClick: () => onSubmit("/login"),
    leftSection: <IconLogin2 size={24} stroke={1.5} />,
  },
  {
    id: "discovery-feed",
    label: "Discovery Feed",
    description: "Subscribe to our RSS feed for the latest updates",
    onClick: () => onSubmit("/discovery-feed"),
    leftSection: <IconRss size={24} stroke={1.5} />,
  },
  {
    id: "atlas",
    label: "Atlas",
    description: "View the full structure of the website",
    onClick: () => onSubmit("/atlas"),
    leftSection: <IconMap size={24} stroke={1.5} />,
  },
  {
    id: "admin-panel",
    label: "Dashboard",
    description: "Access to your admin panel",
    onClick: () => onSubmit("/admin-panel"),
    leftSection: <IconDashboard size={24} stroke={1.5} />,
  },
  {
    id: "about-us",
    label: "About us",
    description: "Just a tiny team (sometimes just coffee and code) building stuff that everyone can actually use...",
    onClick: () => onSubmit("/about-us"),
    leftSection: <IconDashboard size={24} stroke={1.5} />,
  },
]);
